import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import VueFullpage from 'vue-fullpage.js'
Vue.use(VueFullpage)

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
Vue.use(VueAwesomeSwiper)

import './assets/css/base.css'

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: (h) => h(App)
}).$mount('#app')
